export type Comparable = string | number | bigint | null | undefined;

/** Returns true when both values stringify (and trim) to the same value. Two nullish values are considered equal; a nullish vs non-nullish is not. */
export const isEqualString = (a: Comparable, b: Comparable): boolean => {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  return String(a).trim() === String(b).trim();
};

/** The rank data the API sorts records by; see the backend's mayet package. */
export type Ranked = {
  label: string;
  rankValues?: number[];
  rankAttributes?: string[];
};

/**
 * Mirrors mayet.SortByRanks, which the API sorts ranked records with: pairwise over the rank values
 * and their attribute fallbacks, then the label as tiebreaker.
 *
 * Comparing tuples of different lengths falls through to the label, exactly as the API does, so a
 * record without ranks sorts by name against records that have them.
 */
export const compareByRanks = (a: Ranked, b: Ranked) => {
  const ranksA = a.rankValues ?? [];
  const ranksB = b.rankValues ?? [];
  const attrsA = a.rankAttributes ?? [];
  const attrsB = b.rankAttributes ?? [];

  if (ranksA.length === ranksB.length && attrsA.length === attrsB.length) {
    for (let i = 0; i < ranksA.length; i++) {
      if (ranksA[i] !== ranksB[i]) return ranksA[i] - ranksB[i];
      if (attrsA[i] !== attrsB[i]) return attrsA[i] < attrsB[i] ? -1 : 1;
    }
  }

  // Byte order, not locale: cmp.Compare on the API side does the same.
  return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
};
